@if (situationData?.deliveryType === DeliveryType.CHANGE) {
  <div class="re-mb-45">
    <h5 class="re-mb-30">
      {{ 'summary.situation.cancel.title' | translate: { division: divisionTitle } }}
    </h5>
    <ul class="bdo-list__bullet re-mt-30">
      @if (situationData.termination === 'auto' || situationData.revocationWanted) {
        <li>
          {{ 'summary.situation.cancel.auto' | translate: { division: divisionTitle } }}
        </li>
      } @else {
        <li>
          {{ 'summary.situation.cancel.self' | translate: { division: divisionTitle } }}
        </li>
      }
    </ul>
  </div>
}

<h5 class="re-mb-30">
  {{ 'delivery.situation.details.title' | translate }}
</h5>

<div class="re-summary-row">
  <div>{{ 'delivery.situation.details.startDate' | translate }}</div>
  <div>{{ situationData?.startDate | date: 'dd.MM.yyyy' }}</div>
</div>

@if (situationData?.previousSupplier) {
  <div class="re-summary-row">
    <div>{{ 'delivery.situation.details.previousSupplierShort' | translate }}</div>
    <div>{{ situationData.previousSupplier }}</div>
  </div>
}


@for (meter of meterData; track meter) {
  <div>
    <h5 class="re-mb-30 re-mt-45">
      {{ 'general.tariff.meterWithDivision' | translate: { division: meter.divisionId | verbrauchstyp } }}
      @if (hasDuplicateDivision(meter)) { {{ getMeterIndex(meter) }} }
    </h5>
    <div class="re-summary-row">
      <div>{{ 'general.customerData.meternumber' | translate }}</div>
      <div>{{ meter?.meterNumber }}</div>
    </div>
    @if (meter.register?.length && situationData.deliveryType === DeliveryType.MOVE) {
      @for (register of meter?.register; track register) {
        <div class="re-summary-row">
          @if (register.wert) {
            <div>{{ 'meterreadings.meterreading' | translate }} {{ ['HT', 'NT'].includes(register.typ) ? ('' | zaehlwerktyp: register.typ) : '' }}</div>
            <div>{{ register?.wert}} {{ register?.einheit | unitPretty }}</div>
          }
        </div>
      }
    }
    <!-- Optional for meters with separate previous Suppliers / cancellations -->
    @if (meter.previousSupplier) {
      <div class="re-summary-row">
        <div>{{ 'delivery.situation.details.previousSupplierShort' | translate }}</div>
        <div>{{ meter?.previousSupplier }}</div>
      </div>
    }
    @if (meter.termination) {
      <ul class="bdo-list__bullet re-mt-15">
        @if (meter.termination === 'auto') {
          <li>
            {{ 'summary.situation.cancel.auto' | translate: { division: meter.divisionId | verbrauchstyp } }}
          </li>
        } @else {
          <li>
            {{ 'summary.situation.cancel.self' | translate: { division: meter.divisionId | verbrauchstyp } }}
          </li>
        }
      </ul>
    }
  </div>
}
